import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  blogList: [],
}

export const getters = {}

export const mutations = {
  CACHE_BLOG_LIST(state, newList) {
    state.blogList = newList
  },
}

export const actions = {
  // Blog List Service
  fetchBlogList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/blog/list?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_BLOG_LIST', list)
        return list
      })
  },

  // Add Blog Service
  addBlogData({ commit, state, rootState }, { blogData }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/blog`, blogData)
      .then((response) => {
        const blog = response.data
        return blog
      })
  },

  updateBlog({ commit, state, rootState }, { blogData }) {
    return axios
      .patch(
        `${process.env.VUE_APP_API_BASE_URL}/blog/${blogData.id}`,
        blogData
      )
      .then((response) => {
        const data = response.data
        return data
      })
  },

  deleteBlog({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/blog/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },

  getSignedImage({ commit, state, rootState }, data) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/imageurl?image=${data}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
